var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentsCanceled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d1315c;}.cls-2,.cls-3{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.cls-2{stroke-width:55px;}.cls-3{stroke-width:70px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cancel-2",
    "data-name": "cancel"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300,
    cy: 301.08,
    r: 299.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 189.15,
    y1: 404.69,
    x2: 409.8,
    y2: 194.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 300.14,
    cy: 299.03,
    r: 158
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentsCanceled);
export default __webpack_public_path__ + "static/media/appointments_canceled.21da1ef3b6f902fd83566b46a101e65c.svg";
export { ForwardRef as ReactComponent };